import { AspectRatioService } from './../../../services/aspect-ratio.service';
import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
	selector: 'bb-aspect-ratio-picker',
	templateUrl: './bb-aspect-ratio-picker.component.html',
	styleUrls: ['./bb-aspect-ratio-picker.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => BbAspectRatioPickerComponent),
		multi: true
	}]
})

export class BbAspectRatioPickerComponent implements ControlValueAccessor, OnDestroy, OnInit {
	@Input() defaultOption?: string;
	@Input() defaultOptionSublabel?: string; // optional when providing defaultOption
	@Input() valueProp: 'name' | 'value' = 'value'; // input/output for name (e.g. landscape) or value (e.g. 16:9). Note: only name is unique

	aspectRatio = '';
	modelValue = '';

	availableOptions = [];

	private subscriptions = new Subscription();

	constructor(
		public aspectRatioService: AspectRatioService
	) { }

	ngOnInit(): void {
		this.subscriptions.add(this.aspectRatioService.aspectRatiosObs.subscribe(r => {
			const added = [];
			// edge case: remove duplicated w/h for value (e.g. 2 cropsets with 16:9, pick first so dropdown works correctly with unique values)
			if (this.valueProp === 'value') {
				this.availableOptions = r?.filter((set, i) => !set.default && r.findIndex(setCheck => setCheck.aspectwidth === set.aspectwidth && setCheck.aspectheight === set.aspectheight) === i);
			} else {
				// name is unique
				this.availableOptions = r?.filter(set => !set.default);
			}
		}));
	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}

	onChange() {
		this.modelValue = this.aspectRatioService.aspectRatios.find(o => o[this.valueProp] === this.aspectRatio)?.[this.valueProp] || '';
		this.propagateChange(this.modelValue);
	}

	// ControlValueAccessor interface methods
	writeValue(value: any) {
		if (value !== this.modelValue) {
			this.modelValue = value || '';
		}
		if (!this.modelValue) {
			this.modelValue = '';
		}
		this.aspectRatio = this.aspectRatioService.aspectRatios.find(o => o[this.valueProp] === this.modelValue)?.[this.valueProp] || '';
	}

	propagateChange = (_: any) => { };

	registerOnChange(fn: any) {
		this.propagateChange = fn;
	}

	registerOnTouched() {

	}
}
